import React, { createContext, useContext, useMemo } from 'react';
import { GridBreadcrumb } from '../grid-types';
import { LinkFieldRouter } from 'components/link-field/link-field';
import { LevelDefaultIcon, levelIcon } from './breadcrumbs-hook';
import { Theme, Tooltip, createStyles, makeStyles } from '@material-ui/core';
import { Breadcrumb, BreadcrumbsContext } from '../v2/context/curmbs-context';

export type ItemHierarchyContextType = { hierarchyPath: GridBreadcrumb[] };

const ItemHierarchyContext = createContext<ItemHierarchyContextType>({
  hierarchyPath: [],
});

export const ItemHierarchyContextProvider: React.FC<{
  value: ItemHierarchyContextType;
}> = ({ value, children }) => {
  const ctx = useMemo(() => value, [value]);
  return (
    <ItemHierarchyContext.Provider value={ctx}>
      {children}
    </ItemHierarchyContext.Provider>
  );
};

export const useItemHierarchyContext = () => useContext(ItemHierarchyContext);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    linkValue: {
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      marginRight: '8px',
    },
    tooltip: {
      fontSize: 14,
    },
  })
);

export const NavToParentField2 = ({
  target = '_self',
  localBreadcrumbs = [],
}: {
  target?: string;
  localBreadcrumbs?: Breadcrumb[];
}) => {
  const breadcrumbs = useContext(BreadcrumbsContext);
  //console.log({ breadcrumbs });
  const classes = useStyles();
  if ((!breadcrumbs || breadcrumbs.length < 1) && localBreadcrumbs.length < 1) {
    return <></>;
  }
  const crumb =
    breadcrumbs?.[breadcrumbs.length - 2] ??
    localBreadcrumbs?.[localBreadcrumbs.length - 2];
  if (!crumb) {
    return <></>;
  }
  const name = crumb?.label ?? '';
  //console.log({ crumb });
  const timeRange = crumb?.timeRange;
  const Icon = levelIcon[crumb?.level ?? 'fond'] ?? LevelDefaultIcon;

  return (
    <LinkFieldRouter
      label="Nadřazená úroveň"
      to={crumb?.to ?? '#'}
      target={target}
      value={
        <Tooltip
          title={
            <span className={classes.tooltip}>{crumb?.levelLabel ?? ''}</span>
          }
          placement="left-start"
          enterDelay={500}
          enterNextDelay={500}
        >
          <div className={classes.linkValue}>
            <Icon fontSize="small" className={classes.icon} />

            {`${name} ${timeRange ? timeRange : ''}`}
          </div>
        </Tooltip>
      }
    />
  );
};
